import { MutationTree } from 'vuex';
import { OrderInfoInterface } from './state';

const mutation: MutationTree<OrderInfoInterface> = {
  updateOrderInfo(state: OrderInfoInterface, orderInfo: OrderInfoInterface) {
    state.dealerLocation = orderInfo.dealerLocation,
    state.reference   = orderInfo.reference,
    state.requisition = orderInfo.requisition,
    state.modeOfDelivery = orderInfo.modeOfDelivery,
    state.orderType = orderInfo.orderType,
    state.vin = orderInfo.vin,
    state.contactName = orderInfo.contactName,
    state.contactEmail = orderInfo.contactEmail,
    state.contactPhone = orderInfo.contactPhone,
    state.deliveryName = orderInfo.deliveryName,
    state.oneTimeDelivery = orderInfo.oneTimeDelivery,
    state.deliveryAddress= orderInfo.deliveryAddress,
    state.addressInfo = orderInfo.addressInfo,
    state.shippingName = orderInfo.shippingName,
    state.shippingPhone = orderInfo.shippingPhone
  }
}


export default mutation;